export default __webpack_public_path__ + "static/media/right_arrow_blue.6ec7dc18.svg";